
import { Component, OnInit } from '@angular/core';
import { LocalStorage, MenuItems, Modules, SubMenues } from 'src/app/appCommon/Enums/enum';
import { AuthService } from 'src/app/appServices/AuthService/auth.service';
import { HelperService } from 'src/app/appServices/HelperService/helper.service';
@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {
  roleAccessResult:any = [];
  isAccessToDefine: boolean = false;
  isAccessToPiTeam:boolean = false;
  isAccessToRoleAssignment: boolean = false;
  isAccessToUsers: boolean = false;
  isAccessToFacilityBenchmarks: boolean = false;
  isAccessToFacilitySpecs: boolean = false;
  isAccessToStandardProcess: boolean = false;
  isAccessToMeasure: boolean = false;
  isAccessToCaseFollowUp: boolean = false;
  isAccessToAnalyze: boolean = false;
  isAccessToFacilityPI: boolean = false;
  isAccessToRCA: boolean = false;
  isAccessToImprove: boolean = false;
  isAccessToDefault: boolean = false;
  isAccessToControl: boolean = false;
  profileImageUrl: any;
  event:any = '';
  toggleSubControlMain: boolean = false;
  isAccessToQMSReports: boolean = false;
  isAccessToStrokeQualityMetrics: boolean = false;
  isAccessToMRS: boolean = false;
  isAccessToRapidITrending: boolean = false;
  constructor(private helperService: HelperService, private authService: AuthService) {
  }
  toggleMain = false;
  toggleSubMenu = false;
  toggleAnalyzeMain = false;
  toggleControlMain = false;
  toggleMeasureMain = false;
  toggleImproveMain = false;

  ngOnInit(): void {
    this.profileImageUrl = this.helperService.decryption(localStorage.getItem(LocalStorage.UserImageUrl));
    this.profileImageUrl = this.profileImageUrl.toString();
    //set default image
    if (this.profileImageUrl == "not available") {
      this.profileImageUrl = '/assets/images/users/user.jpg';
    }
    this.roleAccessResult = JSON.parse(this.helperService.decryption(localStorage.getItem('roleAccessResult')));
     this.roleAccessResult.forEach((item: any) => {
   
     if(item.com_page_title == MenuItems.Define && item.cac_isAllowed == true){
      this.isAccessToDefine = true;
     }
     else if(item.com_page_title == MenuItems.PiTeam && item.cac_isAllowed == true){
      this.isAccessToPiTeam = true;
     }
     else if(item.com_page_title == MenuItems.RolesAssignment && item.cac_isAllowed == true){
      this.isAccessToRoleAssignment = true;
     }
     else if(item.com_page_title == MenuItems.QMSUsers && item.cac_isAllowed == true){
      this.isAccessToUsers = true;
     }
     else if(item.com_page_title == MenuItems.FacilityBenchmarks && item.cac_isAllowed == true){
      this.isAccessToFacilityBenchmarks = true;
     }
     else if(item.com_page_title == MenuItems.FacilitySpecs && item.cac_isAllowed == true){
      this.isAccessToFacilitySpecs = true;
     }
     else if(item.com_page_title == MenuItems.StandardProcess && item.cac_isAllowed == true){
      this.isAccessToStandardProcess = true;
     }
     else if(item.com_page_title == MenuItems.Measure && item.cac_isAllowed == true){
      this.isAccessToMeasure = true;
     }
     else if(item.com_page_title == MenuItems.CaseFollowUp && item.cac_isAllowed == true){
      this.isAccessToCaseFollowUp = true;
     }
     else if(item.com_page_title == MenuItems.Analyze && item.cac_isAllowed == true){
      this.isAccessToAnalyze = true;
     }
     else if(item.com_page_title == MenuItems.FacilityPI && item.cac_isAllowed == true){
      this.isAccessToFacilityPI = true;
     }
     else if(item.com_page_title == MenuItems.RCA && item.cac_isAllowed == true){
      this.isAccessToRCA = true;
     }
     else if(item.com_page_title == MenuItems.Improve && item.cac_isAllowed == true){
      this.isAccessToImprove = true;
     }
     else if(item.com_page_title == MenuItems.PIReports && item.cac_isAllowed == true){
      this.isAccessToDefault = true;
     }
     else if(item.com_page_title == MenuItems.Control && item.cac_isAllowed == true){
      this.isAccessToControl = true;
     }
     else if(item.com_page_title == MenuItems.QMSReports && item.cac_isAllowed == true){
      this.isAccessToQMSReports = true;
     }
     else if(item.com_page_title == MenuItems.StrokeQualityMetrics && item.cac_isAllowed == true){
      this.isAccessToStrokeQualityMetrics = true;
     }
     else if(item.com_page_title == MenuItems.MRS && item.cac_isAllowed == true){
      this.isAccessToMRS = true;
     }
     else if(item.com_page_title == MenuItems.RapidiTrending && item.cac_isAllowed == true){
      this.isAccessToRapidITrending = true;
     }
    })
  }

  logOut() {
    this.authService.logout();
  }
  togglemenu(event: any){
    this.toggleMain = !this.toggleMain ;
    if (!this.toggleMain) {
      this.toggleSubMenu = false;
    }
  }
  togglesubmenu(event: any){
    this.toggleSubMenu = !this.toggleSubMenu ;
  }
  toggleAnalyzeMenu(event: any){
    this.toggleAnalyzeMain = !this. toggleAnalyzeMain ;
  }
  toggleControlMenu(event: any){
    this.toggleControlMain= !this. toggleControlMain;
    if(!this.toggleControlMain){
      this.toggleSubControlMain = false;
    }
  }
  toggleSubControlMenu(event: any){
    this.toggleSubControlMain= !this. toggleSubControlMain;
    $('.Controldash-hover li').on('click',function(){
      $(this).addClass('active');
    })
  }
  toggleMeasureMenu(event: any){
    this.toggleMeasureMain= !this.toggleMeasureMain;
  }
  toggleImproveMenu(event: any){
    this.toggleImproveMain= !this.toggleImproveMain;
  }

  onContextMenu(event:any){
    event.preventDefault();
  }
}


